import React, { useMemo } from 'react'
import AsyncDropdown, { PropsWithAsyncDropdown } from 'core/elements/dropdown/AsyncDropdown'

interface Props {
  results: string[]
}

export default function ResultPicklist({
  name = 'result',
  label = 'Result',
  compact = false,
  results = [],
  ...rest
}: PropsWithAsyncDropdown<Props>) {
  const options = useMemo(() => {
    return results.map((type) => ({
      label: type,
      value: type,
    }))
  }, [results])
  return <AsyncDropdown compact={compact} name={name} label={label} items={options} {...rest} />
}
